const DEFAULT_DEV_API_BASE_URL = 'http://localhost:8000';

const valueFromEnv = (process.env.REACT_APP_API_BASE_URL || '').trim();

if (!valueFromEnv && process.env.NODE_ENV === 'production') {
  throw new Error('REACT_APP_API_BASE_URL must be defined for production builds.');
}

export const API_BASE_URL = valueFromEnv || DEFAULT_DEV_API_BASE_URL;

// reCAPTCHA Site Key (optional - if not set, CAPTCHA will be skipped)
// For testing, you can use Google's test site key: 6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

// Stripe Publishable Key (required for billing)
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
